export default __webpack_public_path__ + "static/media/image_1.22a752d1.png";